export class Sim {
  constructor(
    public readonly mcc: number,
    public readonly mnc: string,
    public readonly iccId: string,
    public readonly carrierName: string,
    public readonly phoneNumber: string
  ) {}
}
